import React from 'react';

import type { EventRecord } from '@vlabs/api/artemy/model';

import { EventPreview } from './EventPreview.jsx';
import st from './EventRoll.module.sass';
import { Settings } from './Settings';
import type { SidebarName } from './Settings';

export { EVENT_ROLL_SIDEBARS } from './Settings';
export type { SidebarName } from './Settings';

interface EventRollProps {
  activeSidebar: SidebarName | null;
  onToggleSidebar: (name: SidebarName) => void;
  events?: EventRecord[];
}

export function EventRoll({
  activeSidebar,
  onToggleSidebar,
  events = [],
}: EventRollProps): React.JSX.Element {
  return (
    <div className={st.Root}>
      <Settings
        activeSidebar={activeSidebar}
        onToggleSidebar={onToggleSidebar}
      />
      <div className={st.List}>
        {events?.map((event) => (
          <EventPreview
            event={event}
            key={event?.event_id}
          />
        ))}
      </div>
    </div>
  );
}
